export const APP_URL = process.env.NEXT_PUBLIC_APP_URL as string;
export const LANDING_URL = process.env.NEXT_PUBLIC_LANDING_URL as string;

// TODO: Move to shared package
export const REFERRAL_CODE_COOKIE = "refCode";
export const AUTH_TOKEN_COOKIE = "token";

export const GOOGLE_TAG_MANAGER_ID =
	process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;
export const POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_KEY as string;
export const GLEAP_API_KEY = process.env.NEXT_PUBLIC_GLEAP_API_KEY as string;
export const VERCEL_ENV = process.env.NEXT_PUBLIC_VERCEL_ENV as string;

export const DISCORD_URL = "https://discord.gg/EnQCG3eFPd";
export const LINKEDIN_URL = "https://www.linkedin.com/company/zetaai/";
export const X_URL = "https://x.com/jace_ai";
export const YOUTUBE_URL =
	"https://www.youtube.com/channel/UC19cHiXUvbh689yNEowobeg";
export const TIKTOK_URL = "https://www.tiktok.com/@tryjace";
export const INSTAGRAM_URL = "https://www.instagram.com/tryjace/";
export const CAREERS_EMAIL = "careers@zetalabs.ai";
export const DEMO_BOOKING_URL = "https://calendly.com/zetalabs/jace-chat";
export const DEMO_VIDEO_URL = "https://fast.wistia.net/embed/iframe/zn2iinwox3";
